module.exports = __webpack_public_path__ + "static/media/positive.5f841568.svg";